import React from "react";

function GraphImageRenderer({ imageUrl, idx, name }) {
    return (
        <div
            id={`graph-image-${idx}`}
            style={{ 
                width: "100%", 
                height: "100%", 
                display: "flex", 
                justifyContent: "center", 
                alignItems: "center",
                minHeight: "300px"
            }}
        >
            <img
                src={imageUrl}
                alt={name || `Graph ${idx}`}
                style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "contain",
                    borderRadius: "4px"
                }}
                onError={(e) => {
                    console.error("Failed to load image:", imageUrl);
                    e.target.style.display = "none";
                    e.target.parentNode.innerHTML = `
                        <div style="
                            display: flex; 
                            flex-direction: column; 
                            align-items: center; 
                            justify-content: center; 
                            color: #666; 
                            padding: 20px;
                            text-align: center;
                        ">
                            <div style="font-size: 48px; margin-bottom: 16px;">📊</div>
                            <div>Failed to load image</div>
                            <div style="font-size: 12px; margin-top: 8px; color: #999;">
                                ${name || 'Graph'}
                            </div>
                        </div>
                    `;
                }}
            />
        </div>
    );
}

export default GraphImageRenderer;
